"use strict";

export function initInScope ($scope) {
    const   $storesliders =  $scope.find('.js-store-slider');


    if (!$storesliders.length) {
        return;
    }

    import('@elements/slider').then(() =>{
        $storesliders.each(function (i, storeslider) {
            let $storesliders = $(storeslider)

            let storeSliderOptions = {
                prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow" aria-label="Previous"><span class="icon icon-arrow-left" aria-hidden="true"></span></button>',
                nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow" aria-label="Next"><span class="icon icon-arrow-right" aria-hidden="true"></span></button>',
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                cssEase: 'ease-in-out',
                touchThreshold: 100,
            };
            $storesliders.not('.slick-initialized').slick(storeSliderOptions);
        });
    });
}